// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__nJCCw","moduleTitle":"styles_moduleTitle__1pwEX","moduleContent":"styles_moduleContent__HtbiG","editIcon":"styles_editIcon__1wRoP"};